import React from "react";

import { useLocation, useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";

import { extractFirstPath } from "../util";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  backButton: {
    marginRight: theme.spacing(2),
  },
}));

export default function DenseAppBar({
  title = "",
  useBack = false,
  handleBack,
}) {
  const classes = useStyles();
  return (
    <AppBar position="fixed">
      <Toolbar variant="dense">
        {useBack && (
          <IconButton
            edge="start"
            className={classes.backButton}
            color="inherit"
            aria-label="menu"
            onClick={handleBack}
          >
            <ChevronLeftIcon />
          </IconButton>
        )}
        <Typography variant="h6" color="inherit">
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
